import React, { useEffect } from 'react';

import { useFilters } from '@/utils';

import { useFavoriteReportHandler } from '../../hooks';
import { ReportDetailsProps, ReportTab, ReportTypeKeys } from '../../report.types';
import { useGetReportEmployerId } from '../hooks';
import ReportDetailsBase from '../ReportDetailsBase';

import {
  ContributionInvoiceReportTableParams,
  ContributionInvoiceSummaryReportParams,
} from './ContributionInvoiceReport.types';
import ContributionInvoiceReportSummary from './ContributionInvoiceReportSummary';
import ContributionInvoiceReportTable from './ContributionInvoiceReportTable';

type FiltersValues = ContributionInvoiceReportTableParams &
  ContributionInvoiceSummaryReportParams & {
    tab: ReportTab;
  };
interface Props extends ReportDetailsProps<FiltersValues> {}
const ContributionInvoiceReportDetails: React.FC<Props> = ({
  defaultEmployerId,
  defaultTab,
  isPreviewMode,
  onChangeFilters,
  defaultFilterValues,
}) => {
  const employerId = useGetReportEmployerId();
  const { filtersValues, setFilterValue } = useFilters<FiltersValues>(
    {
      tab: defaultTab || ReportTab.Summary,
      employerId: defaultEmployerId || employerId || '',
      searchString: '',
      isSSNShowed: false,
      startDate: null,
      endDate: null,
      invoiceID: '',
      ...defaultFilterValues,
    },
    {
      disabled: isPreviewMode,
      autoClear: true,
    }
  );

  useEffect(() => {
    if (isPreviewMode) {
      return;
    }
    setFilterValue.startDate(null);
    setFilterValue.endDate(null);
    setFilterValue.invoiceID('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtersValues.employerId, filtersValues.employerIds?.join(',')]);
  useEffect(() => {
    if (employerId && !filtersValues.employerId) {
      setFilterValue.employerId(employerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employerId]);
  useEffect(() => {
    if (defaultTab) {
      setFilterValue.tab(defaultTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTab]);
  useEffect(() => {
    if (isPreviewMode && onChangeFilters) {
      onChangeFilters(filtersValues);
    }
  }, [filtersValues, isPreviewMode, onChangeFilters]);
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.ContributionInvoice);
  return (
    <ReportDetailsBase
      isPreviewMode={isPreviewMode}
      isFavorite={isFavorite}
      onToggleFavorite={handleToggleReportKey}
      tab={filtersValues.tab}
      onSetTab={setFilterValue.tab}
      title="Contribution Invoice"
    >
      {filtersValues.tab === ReportTab.Report ? (
        <ContributionInvoiceReportTable
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          key={filtersValues.tab}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      ) : (
        <ContributionInvoiceReportSummary
          defaultEmployerId={defaultEmployerId}
          isPreviewMode={isPreviewMode}
          filtersValues={filtersValues}
          onSetFilterValue={setFilterValue}
        />
      )}
    </ReportDetailsBase>
  );
};

export default ContributionInvoiceReportDetails;
